export const product = state => state.product;